import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccesoModel } from 'src/app/models/acceso/AccesoModel';
import { IAccesoModel } from 'src/app/models/interfaces/accesos/IAccessoModel';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';

@Component({
  selector: 'app-validar-vigencia',
  templateUrl: './validar-vigencia.component.html',
  styleUrls: ['./validar-vigencia.component.css']
})
export class ValidarVigenciaComponent implements OnInit {
  id: string;
  model: IAccesoModel;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accesoPersonaService: AccesoPersonaService
  ) { 
    this.id = '';
    this.model = new AccesoModel();
    this.model.idEstado=0;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.accesoPersonaService.getByCode(this.id).subscribe((data) => {
      this.model = data;
    });
  }
}
